import i18n from '@/i18n'
import { Message } from 'element-ui'
export default {
  install(Vue, options) {
    Vue.prototype.kdialog = {
      show: async (name, options) => {
        let modules
        let callback = () => {}
        await import('@kso/ui/lib/svgDefs')
        switch (name) {
          case 'copy':
            modules = await Promise.all([
              import('@kso/ui/lib/DialogFileCopy'),
              import('@kso/ui/lib/DialogFileCopy/style.css')
            ])
            callback = (data) => {
              Message({
                dangerouslyUseHTMLString: true,
                message: i18n.t('d835ee6e91', [data.created[0]]),
                type: 'success',
                customClass: 'kui-toast-success'
              })
            }
            break
          case 'move':
            modules = await Promise.all([
              import('@kso/ui/lib/DialogFileMove'),
              import('@kso/ui/lib/DialogFileMove/style.css')
            ])
            callback = (info) => {
              Vue.prototype.$stackhub.commit('remove', {
                id: info.fileid
              })
              Message.success(i18n.t('a83b7c3d4d'))
            }
            break
          case 'fileShare':
            modules = await Promise.all([
              import('@kso/ui/lib/DialogShareFile'),
              import('@kso/ui/lib/DialogShareFile/style.css')
            ])
            // // 默认的 popover 由于版本原因会出现浮动层问题，此处需要使用 @kso/ui 的 popover
            // const { default: Popover } = await import('@kso/ui/node_modules/element-ui/lib/popover.js')
            // Vue.use(Popover)
            break
        }
        let [dialog] = modules || []
        if (dialog) {
          dialog = dialog.default || dialog
          dialog.show(options, callback)
        }
      }
    }
  }
}
